import { render, staticRenderFns } from "./TempoMedioPorAssuntos.vue?vue&type=template&id=0ca64408&lang=pug&"
import script from "./TempoMedioPorAssuntos.vue?vue&type=script&lang=js&"
export * from "./TempoMedioPorAssuntos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports